import React, { useEffect, Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import withDashboard from "../../HOC/withDashboard";
import Pagination from "../../components/NewPagination";
import {
  fetchVirtualCardUsers,
  deleteUserVirtualCard,
} from "../../services/VirtualCardServices";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  IconButton,
  Switch,
  CircularProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import "./index.css";
import Loader from "../../components/Loader";

const VirtualCardUsers = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  // State for paginated data
  // Pagination states for cards
  const [totalUserCardData, setTotalUserCardData] = useState(0);
  const [userCardData, setUserCardData] = React.useState([]);
  const [userCardDataFilter, setUserCardDataFilter] = useState({
    search: "",
    page: 0,
    limit: 10,
  });
  const statusLabels = {
    pending: "Pending (Not Sent)",
    "pending-api-approval": "Pending API Approval",
    "api-rejected": "Rejected by API",
    "pending-admin-approval": "Pending Admin Approval",
    "admin-rejected": "Rejected by Admin",
    approved: "Approved",
    active: "Active",
    rejected: "Rejected",
    suspended: "Suspended",
  };

  useEffect(() => {
    getUserCardData();
  }, [userCardDataFilter]);

  const onChangeUserCardDataFilter = (name, value) => {
    setUserCardDataFilter({ ...userCardDataFilter, [name]: value });
  };

  const getUserCardData = () => {
    setIsLoading(true);
    dispatch(fetchVirtualCardUsers(userCardDataFilter))
      .then((res) => {
        setTotalUserCardData(res?.data?.data?.total);
        setUserCardData(res?.data?.data?.data);
        setIsLoading(false);
      })
      .catch(({ message, errorData, statusCode }) => {
        console.error("Error fetching virtual card users:", message);
        setIsLoading(false);
      });
  };

  const deleteUserVirtualCardFun = async (userCardId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Delete this user card profile.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        dispatch(deleteUserVirtualCard({ userCardId: userCardId }))
          .then((res) => {
            setIsLoading(false);
            getUserCardData();
            Swal.fire(
              "Success",
              "User card profile deleted successfully",
              "success"
            );
          })
          .catch(({ message, errorData, statusCode }) => {
            Swal.fire("Error", "Failed to delete user card profile", "error");
            setIsLoading(false);
          });
      }
    });
  };

  return (
    <Fragment>
      <div className="gift-cards-container">
        <div className="gift-cards-button-container"></div>

        {/* Gift Card Categories Section */}
        <Card className="gift-cards-category-card">
          <div className="table-title mb-2">
            <span>Virtual Card Users</span>
          </div>
          <div className="gift-cards-table-container mb-5">
            {isLoading ? (
              <div className="flex justify-center items-center p-4">
                <CircularProgress />
              </div>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>Phone No</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {userCardData &&
                    userCardData.length > 0 &&
                    userCardData.map((useCard) => (
                      <tr key={useCard._id}>
                        <td>{useCard?.firstName}</td>
                        <td>{useCard?.lastName}</td>
                        <td>{useCard?.email}</td>
                        <td>{useCard?.phone}</td>
                        <td>
                          {statusLabels[useCard?.status] || "Unknown Status"}
                        </td>
                        <td>
                          <IconButton
                            onClick={() =>
                              navigate("/virtual-card-user/edit/" + useCard._id)
                            }
                          >
                            <EditIcon />
                          </IconButton>
                          {useCard?.status === "approved" ||
                          useCard?.status === "active" ? (
                            <></>
                          ) : (
                            <IconButton
                              onClick={() =>
                                deleteUserVirtualCardFun(useCard._id)
                              }
                            >
                              <DeleteIcon />
                            </IconButton>
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            )}
          </div>
          <div className="gift-cards-pagination-container">
            <Pagination
              items={totalUserCardData}
              initialPage={userCardDataFilter?.page}
              onChangePage={onChangeUserCardDataFilter}
              per_page={userCardDataFilter?.limit}
            />
          </div>
        </Card>
      </div>
      <Loader />
    </Fragment>
  );
};

export default withDashboard(VirtualCardUsers);
